export const layanan = [
  {
    title: "Peminjaman Buku",
    image: "/image/layanan/peminjaman_buku.png",
    path: "/peminjaman"
  },
  {
    title: "Koleksi Cetak",
    image: "/image/layanan/koleksi_cetak.png",
    path: "/koleksi-cetak"
  },
  {
    title: "Koleksi Elektronik",
    image: "/image/layanan/koleksi_elektronik.png",
    path: "/koleksi-elektronik"
  },
  {
    title: "Layanan Sirkulasi",
    image: "/image/layanan/layanan_sirkulasi.png",
    path: "/pelayanan-sirkulasi"
  },
  {
    title: "Surat Bebas Perpustakaan",
    image: "/image/layanan/sbp.png",
    path: "/sbp"
  },
  {
    title: "Meja Baca",
    image: "/image/layanan/meja_baca.png",
    path: "/baca"
  }
];